import appleWatchUltra from '@/assets/device-icons/apple-watch-ultra.svg';

interface AppleWatchUltraIconProps {
  className?: string;
}

export const AppleWatchUltraIcon = ({ className = "h-5 w-5" }: AppleWatchUltraIconProps) => {
  return (
    <img 
      src={appleWatchUltra} 
      alt="Apple Watch Ultra" 
      className={className}
    />
  );
};
